<footer *ngIf="!isLoading; else loadingFooter">
  <div class="wrapper">
    <!-- 642706 the first row should be deleted -->
    <!--
    <div class="first-row">
      <div class="contact">
        <h6 *ngIf="headline1">{{ headline1 }}</h6>
        <ng-container *ngFor="let card of cards; let i = index">
          <ng-container *ngIf="i === 0">
            <hdi-bubble [label]="'Jetzt kontaktieren'"></hdi-bubble>
          </ng-container>
          <hdi-card
            [icon]="card.icon"
            [title]="card ? card.title : ''"
            [textLink]="card.textLink"
            [link]="card.link"
            [linkType]="card.linkType"
            [date]="card.date"
            [subtitle]="card.subtitle"
            [disabled]="card.disabled"
            [iconColor]="card.iconColor"
            [linkTarget]="card.linkTarget"
          ></hdi-card>
        </ng-container>
      </div>

      <div class="links" *ngIf="links?.length">
        <h6 *ngIf="headline2">{{ headline2 }}</h6>
        <ng-container *ngFor="let link of links">
          <hdi-link
            [href]="link.href ?? '/'"
            [label]="link.label | capitalize"
            [type]="link.linkType ?? LinkType.DOWNLOAD_NO_UNDERSCORED"
            [hrefType]="link.hrefType ? link.hrefType : HrefType.ANGULAR_ROUTE"
            [target]="link.target ?? '_self'"
            [size]="Sizes.SMALL"
          ></hdi-link>
        </ng-container>
      </div>

      <div class="support" *ngIf="textBtnCards?.length">
        <h6 *ngIf="headline3">{{ headline3 }}</h6>
        <hdi-card
          [type]="CardType.FOOTER"
          [title]="textBtnCards[0].title || ''"
          [subtitle]="textBtnCards[0].subtitle || ''"
          [btnLabel]="textBtnCards[0].btnLabel || ''"
          [btnHref]="textBtnCards[0].btnHref || ''"
          [btnHrefType]="textBtnCards[0].btnHrefType || HrefType.ANGULAR_ROUTE"
          [strongText]="
            textBtnCards[0].btnHeadline ? textBtnCards[0].btnHeadline : ''
          "
          [btnTarget]="textBtnCards[0].btnTarget || '_self'"
          [linkTitle]="textBtnCards[0].linkTitle ?? ''"
          [linkRel]="textBtnCards[0].linkRel"
        ></hdi-card>
      </div>

      <div class="newsletter" *ngIf="textBtnCards?.[1]">
        <h6 *ngIf="headline4">{{ headline4 }}</h6>
        <hdi-card
          [type]="CardType.FOOTER"
          [title]="textBtnCards[1].title || ''"
          [subtitle]="textBtnCards[1].subtitle || ''"
          [btnLabel]="textBtnCards[1].btnLabel || ''"
          [btnHref]="textBtnCards[1].btnHref || ''"
          [btnHrefType]="textBtnCards[1].btnHrefType || HrefType.ANGULAR_ROUTE"
          [strongText]="
            textBtnCards[1].btnHeadline ? textBtnCards[1].btnHeadline : ''
          "
          [btnTarget]="textBtnCards[1].btnTarget || '_self'"
          [linkTitle]="textBtnCards[1].linkTitle ?? ''"
          [linkRel]="textBtnCards[1].linkRel"
        ></hdi-card>
      </div>
    </div>
-->

    <div class="second-row">
      <div class="social-media" *ngIf="socialLinks?.length">
        <ng-container *ngFor="let link of socialLinks">
          <a
            [href]="link.href"
            target="_blank"
            [attr.aria-label]="link.icon | titlecase"
            [attr.title]="link.icon | titlecase"
          >
            <hdi-icon
              [iconName]="link.icon"
              [iconPrefix]="link.iconPrefix"
              [size]="Sizes.MEDIUM"
              [color]="Colors.BLACK"
            ></hdi-icon>
          </a>
        </ng-container>
      </div>
      <div class="copy-right" *ngIf="!hasInvalidLegalLinks">
        <ng-container *ngFor="let link of legalLinks">
          <hdi-link
            [href]="link.href!"
            [hrefType]="HrefType.ANGULAR_ROUTE"
            [label]="link.label | capitalize"
            [type]="LinkType.INLINE_LIGHT"
            [color]="TextColors.BLACK"
            [size]="Sizes.SMALL"
          ></hdi-link>
        </ng-container>
      </div>
    </div>
  </div>
</footer>

<!-- Loading Placeholder -->
<ng-template #loadingFooter>
  <hdi-footer-loader></hdi-footer-loader>
</ng-template>
